var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginated',{attrs:{"label":"Popular Places","sublabel":"What attractions do your passengers view the most?","main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent}})
}
var staticRenderFns = []

export { render, staticRenderFns }